export default __webpack_public_path__ + "static/SmallBusiness-redesign-5d1d9bfb075d5b12985e797deb928b63.png";